<!-- <div class="privacy">
    <iframe src="https://app.termly.io/document/privacy-policy/b58cb8f9-3535-4d72-abf7-b1ef395cc8dd" width="100%"
        height="7600px" frameborder="0"></iframe>
</div>
-->
<div class="privacy__message-holder" *ngIf="!isShowPrivacy && currentLanguage == 'ar'">
    <div class="privacy__message-info">
        <h3 class="privacy__info-title">
            هذا المحتوى متوفر باللغة الإنجليزية
        </h3>
        <a (click)="showPrivacy()">Privacy Policy</a>
    </div>
</div> 

<div class="privacy">
    <div class="privacy__description-holder">
        <h3>Privacy Policy</h3>
        <p>
            Last Updated: October 20, 2025
            Welcome to Solidrange (“we,” “our,” or “us”).
            We value your trust and are committed to protecting your privacy and the confidentiality of your personal
            information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you
            visit
            <a href="https://www.solidrange.com">www.solidrange.com</a>, use our products or services, or interact with
            us.
        </p>
    </div>

    <div class="privacy__description-holder">
        <h3>1. Who We Are</h3>
        <p>
            Solidrange is a technology company based in Riyadh, Saudi Arabia, providing Governance, Risk, and Compliance (GRC) and Cybersecurity Awareness platforms that help organizations automate compliance, manage risks, and strengthen their cybersecurity posture.
        </p>
        <p>For the purpose of this policy, Solidrange is the data controller responsible for determining how and why your personal information is processed.</p>
    </div>

    <div class="privacy__description-holder">
        <h3>2. Information We Collect</h3>
        <p>We may collect personal and non-personal data through various interactions, including:</p>
        <h4>a. Information You Provide</h4>
        <ul>
            <li>Name, job title, and organization</li>
            <li>mail address and phone number</li>
            <li>Login credentials (for registered users)</li>
            <li>Messages or attachments shared via contact or demo request forms</li>
        </ul>

        <h4>b. Information Collected Automatically</h4>
        <p>When you browse our website, we may automatically collect:</p>
        <ul>
            <li>IP address and device information</li>
            <li>Browser type, operating system, and referring URLs</li>
            <li>Pages visited and time spent on each page</li>
            <li>Cookies and other similar technologies used to enhance your browsing experience</li>
        </ul>

        <h4>c. Information from Third Parties</h4>
        <p>We may receive information from trusted partners, service providers, or analytics platforms to improve our services and communications.</p>





    </div>

    <div class="privacy__description-holder">
        <h3>3. How We Use Your Information</h3>
        <p>We use your data responsibly and only for lawful and transparent purposes, such as:</p>
        <ul>
            <li>Responding to your inquiries or demo requests</li>
            <li>Providing access to our platforms and support services</li>
            <li>Improving our website, products, and customer experience</li>
            <li>Sending relevant updates, announcements, or marketing communications (only with your consent)</li>
            <li>Analyzing traffic and engagement metrics</li>
            <li>Analyzing traffic and engagement metrics</li>
        </ul>
    </div>


    <div class="privacy__description-holder">
        <h3>4. Data Sharing and Disclosure</h3>
        <p>We may share your information with:</p>
        <ul>
            <li>Our authorized employees and contractors</li>
            <li>Technology providers that support our website and cloud services</li>
            <li>Technology providers that support our website and cloud services</li>
        </ul>

        <p>We do not sell, rent, or trade your personal information to third parties.</p>
        <p>If data is transferred or stored outside Saudi Arabia, we ensure that appropriate security measures and safeguards are in place.</p>
    </div>


    <div class="privacy__description-holder">
        <h3>5. Data Retention</h3>
        <p>Your personal information is retained only for as long as necessary to:</p>
        <ul>
            <li>Deliver our services or fulfill your requests</li>
            <li>Meet legal and regulatory requirements</li>
            <li>Meet legal and regulatory requirements</li>
        </ul>

        <p>When your data is no longer needed, it will be securely deleted or anonymized.</p>
    </div>

    <div class="privacy__description-holder">
        <h3>6. Your Rights</h3>
        <p>You have the right to:</p>
        <ul>
            <li>Access and obtain a copy of your personal information</li>
            <li>Request correction of inaccurate or incomplete information</li>
            <li>Request deletion of your data where permitted by law</li>
            <li>Withdraw consent for marketing or communications at any time</li>
        </ul>
        <p>To exercise these rights, contact us at privacy&#64;solidrange.com. </p>
    </div>

     <div class="privacy__description-holder">
        <h3>7. Data Security</h3>
        <p>We apply strict technical and organizational measures to safeguard your data against unauthorized access, loss, misuse, or alteration.</p>
        <p>This includes secure hosting environments, encryption, access control, and regular security monitoring.</p>
     </div>

     <div class="privacy__description-holder">
        <h3>8. Links to Other Sites</h3>
        <p>Our website may include links to external sites operated by third parties. We are not responsible for their content, privacy policies, or practices. Please review their privacy policies before providing personal information.</p>
     </div>

     <div class="privacy__description-holder">
        <h3>9. Policy Updates</h3>
        <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Updates will be posted on this page with a revised “Last Updated” date. We encourage you to review this page regularly.</p>
     </div>

     <div class="privacy__description-holder">
        <h3>10. Contact Us</h3>
        <p>If you have questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact us:</p>
        <div>Riyadh, Kingdom of Saudi Arabia</div>
        <div>info&#64;solidrange.com</div>
        <div><a href="https://www.solidrange.com">www.solidrange.com</a></div>
     </div>


</div>